<template>
    <div class="w-full flex p-2 my-2 bg-red-100 text-red-600 font-medium text-sm rounded-md">
        {{ message }}
    </div>
</template>

<script>
export default {
    props: [ 'message' ]
}
</script>
